import styled from "styled-components";

export const MenuItemWrapper = styled.div`
  width: 33.33%;
  padding: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
